/** Simulation epoch: Thursday 1 January 2026, 00:00 UTC. Sim hour 0 == this instant. */
export const SIM_EPOCH_UTC_MS = Date.UTC(2026, 0, 1, 0, 0, 0);

export interface SimClockParts {
  absoluteHour: number;
  /** 0-based day index since epoch. */
  day: number;
  hourOfDay: number;
  /** 0 = Monday … 6 = Sunday. */
  dayOfWeek: number;
  /** 0 = January … 11 = December. */
  month: number;
  dayOfMonth: number;
  year: number;
}

const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;
const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

export function decodeSimHour(absoluteHour: number): SimClockParts {
  const date = new Date(SIM_EPOCH_UTC_MS + absoluteHour * 3_600_000);
  const jsDayOfWeek = date.getUTCDay(); // 0 = Sunday
  return {
    absoluteHour,
    day: Math.floor(absoluteHour / 24),
    hourOfDay: ((absoluteHour % 24) + 24) % 24,
    dayOfWeek: (jsDayOfWeek + 6) % 7,
    month: date.getUTCMonth(),
    dayOfMonth: date.getUTCDate(),
    year: date.getUTCFullYear(),
  };
}

export function formatSimDate(parts: SimClockParts): string {
  const dd = String(parts.dayOfMonth).padStart(2, '0');
  return `${DAY_NAMES[parts.dayOfWeek]} ${dd} ${MONTH_NAMES[parts.month]} ${parts.year}`;
}

export function formatSimHour(hourOfDay: number): string {
  return `${String(hourOfDay).padStart(2, '0')}:00`;
}
